import React, { useState } from "react";
import "./AddCustomer.scss";

const AddCustomerSection = ({ onCancel, onAdd }) => {
  const [formData, setFormData] = useState({
    username: "",
    mobile: "",
    email: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      // Logic: Remove any non-numeric characters and limit to 10 digits
      const onlyNums = value.replace(/\D/g, "");
      if (onlyNums.length <= 10) {
        setFormData({ ...formData, [name]: onlyNums });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Validation: Button activates only if username is not empty and mobile is 10 digits
  const isFormValid =
    formData.username.trim().length > 0 && formData.mobile.length === 10;

  const Icons = {
    User: () => (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    Phone: () => (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
    Mail: () => (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
    MapPin: () => (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    Close: () => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#5f6368"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    ),
  };

  return (
    <div className="add-customer-section">
      <button className="section-close-btn" onClick={onCancel}>
        <Icons.Close />
      </button>

      <div className="section-header">
        <div className="header-icon-box">
          <Icons.User />
        </div>
        <div className="header-info">
          <h2>Add New Customer</h2>
          <span>Fill in customer details</span>
        </div>
      </div>

      <div className="section-fields">
        <div className="input-field">
          <label>Username</label>
          <div className="field-container">
            <Icons.User />
            <input
              type="text"
              name="username"
              placeholder="Enter username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="input-field">
          <label>Mobile Number</label>
          <div className="field-container">
            <Icons.Phone />
            <input
              type="text"
              name="mobile"
              placeholder="10-digit mobile number"
              value={formData.mobile}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Commented fields preserved for future use */}
        {/* <div className="input-field">
          <label>Email Address</label>
          <div className="field-container">
            <Icons.Mail />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="input-field">
          <label>Address</label>
          <div className="field-container textarea">
            <Icons.MapPin />
            <textarea
              name="address"
              rows="3"
              value={formData.address}
              onChange={handleChange}
            />
          </div>
        </div> 
        */}
      </div>

      <div className="section-actions">
        <button className="cancel-btn" onClick={onCancel}>
          Cancel
        </button>
        <button
          className="submit-btn"
          onClick={() => onAdd(formData)}
          disabled={!isFormValid}
        >
          Add Customer
        </button>
      </div>
    </div>
  );
};

export default AddCustomerSection;
